<template>
  <v-card class="group-card">
    <v-container fluid>
      <v-layout
        align-space-between
        justify-space-around
        column
        fill-height
      >
        <v-flex>
          <v-layout
            align-space-between
            justify-space-around
            row
            fill-height
          >
            <v-flex class="text-xs-left">
              <h3>{{ group.name }}</h3>
            </v-flex>
            <v-flex class="text-xs-right inline">
              <span>{{ strings.outstanding }}: </span>
              <span><h3>{{ group.poiIds.length }}</h3></span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout
            align-center
            justify-space-around
            row
            fill-height
          >
            <v-flex>
              <v-btn
                color="primary"
                dark
                round
                @click="onListButton(group.groupId)"
              >
                <v-icon color="text">
                  mdi-format-list-bulleted-square
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "GroupCard",
  props: ["group"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("page", ["strings"])
  },
  methods: {
    onListButton(id) {
      this.$store.commit("group/setActiveGroup", id);
      this.$store.commit("network/clear");
      this.$router
        .push({ name: "outstanding", params: { id } })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.group-card {
  margin: 0.5em;
}
.text-xs-right.inline {
  display: inline;
}
.text-xs-right.inline span {
  display: inline;
}
.text-xs-right.inline h3 {
  display: inline;
}
</style>
